import React from 'react'
import prettysize from '../../../utils'
import moment from 'moment'
import './styles.scss'
import {Button} from 'antd'

class AWSStatus extends React.Component {
    constructor(props) {
        super(props)


        this.state = {
          maxSpeed : 5 * 1024 * 1024 * 1024 / 8
        }
    }

    componentWillReceiveProps(props) {
      //this.setState({migration:props.migration})
      
    }
  

    render() {
      
      var statusMap = new Map()
      statusMap.set(2, 'Ongoing')
      statusMap.set(4, 'Completed')
      statusMap.set(8, 'Canceled')
      statusMap.set(16, 'Failed')
      statusMap.set(32, 'Canceling')
      statusMap.set(64, 'Pausing')
      statusMap.set(128, 'Paused')

      return (
        <div className={'aws-status'}>
<div className="row">
  <div className="column">
    <p className="title"> 
      {this.props.sourceCloud + ' → ' + this.props.destinationCloud + ' > ' + this.props.destinationBucket}
    </p>
  </div>
  <div className="column">
    <p className="date">
    {moment.parseZone(this.props.batchTransferDateTime).local().format('MM/DD/YYYY - HH:mm')}
    &nbsp;
    Status: {statusMap.get(this.props.transferStatus)}
    </p>
  </div>
</div>
<div>
  <font className="label">Source: </font> 
  <font className="text">{(this.props.sourceBucket + ' > ' + this.props.path).substring(0,70)}</font>
</div>
<div className="row">
  {
    this.props.transferType === 1 ? (  
    <div className="column">
      <font className="label">Total size:</font> 
      <font className="text"> {prettysize(this.props.totalSize)}</font>
    </div>
) : (    <div className="column"></div>)
  }
  <div className="column">
    <font className="label">Total:</font> 
    <font className="text"> {this.props.totalNumber}</font>
  </div>
</div>
<div className="row">
  <div className="column">
    <font className="label">Total Transferred size:</font> 
    <font className="green-text"> {prettysize(this.props.transferedSize)}</font>
  </div>
  <div className="column">
    <font className="label">Transferred:</font> 
    <font className="green-text"> {this.props.transferedNumber}</font>
  </div>
</div>
<div className="row">
  <div className="column">
    <font className="label">Average Speed:</font> 
    <font className="text"> {(this.props.averageSpeed < this.state.maxSpeed ? prettysize(this.props.averageSpeed*8).toTitleCase() : prettysize(this.state.maxSpeed * 8).toTitleCase()) + 'ps'}</font>
  </div>
  <div className="column">
    <font className="label">Skipped:</font> 
    <font className="green-text"> {this.props.skipedNumber}</font>
  </div>
</div>
{this.props.transferType !== 1 ? (
  <div className="row">
  <div className="column">
  </div>
  <div className="column">
    <font className="label">Deleted:</font> 
    <font className="green-text"> {this.props.deletedNumber}</font>
  </div>
</div>
)
:(<div></div>)
}
<div className="row">
  <div className="column">
  </div>
  <div className="column-20">
    <font className="label">Failed:</font> 
    <font className="yellow-text"> {this.props.failedNumber}</font>
  </div>
  <div className="column-30">
    <p className="date">
      {!this.props.retried && this.props.failedNumber != 0 && <Button ref={this.props.batchTransferID} disabled={this.props.onclickDisabled} className="btn-filter" type='primary' size="default" onClick={this.props.onRetry}>Retry Failed Files</Button>}
      &nbsp;
      {this.props.failedNumber != 0 && <Button className="btn-filter" type='primary' size="default" onClick={this.props.onDownload}>Download Failed Files</Button>}
    </p>
  </div>
</div>

</div>

        );
    }
  }

  export default AWSStatus;